import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { UseOpenDraftProps } from './types';
import useOuSwitchPrompt from './useOuSwitchPrompt';
import { useStore } from '30.quickConnect.Stores';
import { DECLARATION } from '10.quickConnect.app/routes/paths';
import { DeclarationViewer } from '90.quickConnect.Models/models';
import { DeclarationLocationState } from '10.quickConnect.app/components/domain/Declaration/types';

/**
 * Reprise d'un brouillon : il se poursuit dans l'UO où il a été saisi. Son UO est transmise à la déclaration, qui refait
 * le même contrôle (ouverture par URL ou nouvel onglet) sans avoir à la rechercher.
 * Les popups de bascule sont rendues par OuSwitchPrompt avec promptProps.
 */
const useOpenDraft = (): UseOpenDraftProps => {
  const {
    OuAccessStore: { decisionForDeclaration },
  } = useStore();
  const navigate = useNavigate();
  const { checkThenRun, promptProps } = useOuSwitchPrompt();

  const openDraft = useCallback(
    async ({ id, formId, organizationalUnitCode }: DeclarationViewer): Promise<void> => {
      const state: DeclarationLocationState = { declarationOuCode: organizationalUnitCode };

      await checkThenRun(
        () => decisionForDeclaration(organizationalUnitCode),
        () => navigate(DECLARATION.replace(':formId', formId).replace(':declarationId', id), { state }),
        { context: 'declaration' },
      );
    },
    [checkThenRun, decisionForDeclaration, navigate],
  );

  return { openDraft, promptProps };
};

export default useOpenDraft;
